import React from 'react';
import { resolveVariableBoxFields, variableBoxFormFields } from '../../../puck/fields/variableBoxFormFields';
import InfoCard from './InfoCard';
import HiddenBlockFrame from '../../../puck/HiddenBlockFrame';
import InfoCardIllustrationField from './InfoCardIllustrationField';
import InfoCardBadgesField from './InfoCardBadgesField';
import InfoCardLogoField from './InfoCardLogoField';
import InfoCardRatingField from './InfoCardRatingField';
import InfoCardStylePicker from './InfoCardStylePicker';
import { puckSwitchField } from '../../../puck/fields/puckSwitchField';
import { puckHorizontalAlignField } from '../../../puck/fields/puckHorizontalAlignField';
import { puckVerticalAlignField } from '../../../puck/fields/puckVerticalAlignField';
import { puckColorField } from '../../../puck/fields/createPuckColorField';
import { puckPxSpacingField } from '../../../puck/fields/puckPxSpacingField';
import { puckBorderField } from '../../../puck/fields/puckBorderField';
import { infoCardDefaultProps } from '../../../../shared/boxes/infoCard/infoCardProps';
import { puckSectionField, puckStyleGallerySectionField } from '../../../puck/fields/puckSectionField';
import { withThemedFieldValues } from '../../../puck/fields/themedFieldValues';
import { puckTextRolesField } from '../../../puck/fields/TextRolesField';
import { puckShadowField } from '../../../puck/fields/puckShadowField';
import { INFO_CARD_GROUPS, INFO_CARD_LABELS } from '../../../../shared/boxes/infoCard/infoCardLabels';
import { SHADOW_LABEL } from '../../../../shared/boxes/shadowStyles';
import {
  themedBlockProps, themedBlockResolveData, themedBlockResolveFields,
} from '../../../puck/themedBlocks';

const infoCardConfig = {
  label: 'Carte info',
  // Démo au drop : l'utilisateur voit le rendu et remplace par ses données.
  defaultProps: {
    ...infoCardDefaultProps(),
    value: '98 %',
    description: 'Clients satisfaits',
  },
  fields: withThemedFieldValues('infoCard', {
    // Galerie de styles : un style est un jeu de valeurs, pas une variante.
    // Déclaré sur `titleStyle` faute de prop « style » persistée — le style
    // actif se déduit des props (voir infoCardStyles.js).

    _section1: puckStyleGallerySectionField('Carte info'),
    titleStyle: {
      type: 'custom',
      label: 'Style de la carte',
      render: () => <InfoCardStylePicker />,
    },

    _section2: puckSectionField(INFO_CARD_GROUPS.illustration),
    // Champ composite : type d'illustration + icône ou photo + couleur, forme
    // et taille dans la même section (édite `icon`, écrit les autres props via
    // replace — voir InfoCardIllustrationField).
    icon: {
      type: 'custom',
      label: 'Illustration',
      render: (props) => <InfoCardIllustrationField {...props} />,
    },
    // Titre et description s'éditent UNIQUEMENT sur le canvas (rich text
    // inline + toolbar) : un éditeur sidebar en double se désynchronisait.

    _section3: puckSectionField(INFO_CARD_GROUPS.decor),
    quoteMark: puckSwitchField(INFO_CARD_LABELS.quoteMark),
    rating: {
      type: 'custom',
      label: INFO_CARD_LABELS.rating,
      render: (props) => <InfoCardRatingField {...props} />,
    },
    ratingColor: puckColorField(INFO_CARD_LABELS.ratingColor, { allowTransparent: true }),
    ratingSize: puckPxSpacingField(INFO_CARD_LABELS.ratingSize),
    logoUrl: {
      type: 'custom',
      label: "Logo de l'entreprise",
      render: (props) => <InfoCardLogoField {...props} />,
    },
    badges: {
      type: 'custom',
      label: INFO_CARD_LABELS.badges,
      render: (props) => <InfoCardBadgesField {...props} />,
    },

    _section4: puckSectionField(INFO_CARD_GROUPS.card),
    cardLayout: {
      type: 'radio',
      label: INFO_CARD_LABELS.cardLayout,
      options: [
        { label: 'Verticale', value: 'vertical' },
        { label: 'Horizontale', value: 'horizontal' },
      ],
    },
    contentAlign: puckHorizontalAlignField(INFO_CARD_LABELS.contentAlign),
    lineGap: puckPxSpacingField(INFO_CARD_LABELS.lineGap),
    padding: puckPxSpacingField('Marge intérieure', 'Vide = 32 px.'),
    backgroundColor: puckColorField(INFO_CARD_LABELS.backgroundColor, { allowTransparent: true }),
    shadow: puckShadowField(SHADOW_LABEL),
    border: puckBorderField('Bordures'),

    _sectionText: puckSectionField('Typographie'),
    textStyles: puckTextRolesField([{ key: 'value', label: 'Titre' }, { key: 'description', label: 'Description' }]),

    ...variableBoxFormFields({ withFormSection: true }),
    _section5: puckSectionField('Affichage'),
    alignHorizontal: puckHorizontalAlignField(),
    alignVertical: puckVerticalAlignField(undefined, { stretch: true }),
  }),
  // Déposée : style par défaut du thème. Réglée à la main : détachée du thème.
  resolveData: themedBlockResolveData('infoCard'),
  resolveFields: (data, context) => resolveVariableBoxFields(
    { type: 'InfoCard', props: data.props },
    themedBlockResolveFields('infoCard')(data, context),
  ),
  render: (props) => (
    <HiddenBlockFrame isVisible={props.isVisible} isEditing={!!props.puck?.isEditing}>
      <InfoCard {...themedBlockProps('infoCard', props, props.puck?.metadata)} />
    </HiddenBlockFrame>
  ),
};

export default infoCardConfig;
